import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { PageWrapper, Loader, Alert } from '../../components';
import { thunks as productThunks } from '../../redux/modules/products';
import Actions, { thunks } from '../../redux/modules/banners';
import BannerModal from './components/bannerModal';
import { isEqual } from "lodash";

class Banners extends React.Component {
    state = {
        bannerToEdit: {},
        screen: 'home',
        bannerToDelete: null,

    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(productThunks.getCategories());
        this.setTableView('home');
    }

    setTableView = (tab) => {
        const { dispatch } = this.props;
        dispatch(thunks.getBanners(tab));
        this.setState({ screen: tab });
    }

    editBanner = banner => {
        this.setState({ bannerToEdit: banner }, () => {
            this.handleAddBanner();
        })
    }

    onCategoryChange = id => {
        const { dispatch } = this.props;
        dispatch(productThunks.getCategories(id));
    }

    handleAddBanner = () => {
        const { updateProperty } = this.props;
        updateProperty('showModal', true);
    }

    closeModal = () => {
        const { updateProperty } = this.props;
        updateProperty('showModal', false);
        this.setState({ bannerToEdit: {} });
    }

    onAddBanner = body => {
        const { dispatch } = this.props;
        dispatch(thunks.addBanner(body));
    }

    onEditBanner = body => {
        const { dispatch } = this.props;
        dispatch(thunks.editBanner(body));
    }

    deleteBanner = (banner) => {
        this.setState({ bannerToDelete: banner })
    }

    handleDeleteBanner = () => {
        const { dispatch } = this.props;
        const { bannerToDelete, screen } = this.state;
        dispatch(thunks.deleteBanner(bannerToDelete.id, screen));
        this.setState({ bannerToDelete: null })

    }

    render() {
        const {
            list,
            loading,
            error,
            updateProperty,
            categories,
            subCategories,
            showModal,
        } = this.props;
        const { bannerToEdit, screen, bannerToDelete } = this.state;

        return (
            <PageWrapper title="Banners List">
                <Loader show={loading} />
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="Banners"
                    message={error}
                />
                <div className="animated fadeIn">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">
                                        <button type="button" className={`mr-2 btn btn-dark  ${screen == 'home' ? 'active-btn' : ''}`} onClick={() => this.setTableView('home')} >Home</button>
                                        <button type="button" className={`mr-2 btn btn-dark  ${screen == 'home_screen_top' ? 'active-btn' : ''}`} onClick={() => this.setTableView('home_screen_top')} >Home Screen Top</button>
                                        <button type="button" className={`mr-2 btn btn-dark  ${screen == 'home_screen_offer_top' ? 'active-btn' : ''}`} onClick={() => this.setTableView('home_screen_offer_top')} >Home Screen Offer Top</button>
                                        <button type="button" className={`mr-2 btn btn-dark  ${screen == 'web_banner_1' ? 'active-btn' : ''}`} onClick={() => this.setTableView('web_banner_1')} >Product Banner Top</button>
                                        <button type="button" className={`mr-2 btn btn-dark  ${screen == 'web_banner_2' ? 'active-btn' : ''}`} onClick={() => this.setTableView('web_banner_2')} >Product Banner Bottom</button>
                                        <button type="button" className={`mr-2 btn btn-dark  ${screen == 'subcategory' ? 'active-btn' : ''}`} onClick={() => this.setTableView('subcategory')} >Sub Category</button>
                                    </h5>
                                    <div className="row">
                                        <div className="col-md-12 d-flex justify-content-end mb-3">
                                            <button className="btn btn-primary" onClick={this.handleAddBanner}>
                                                <i className="fa fa-plus mr-2" />
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Title</th>
                                                    <th>Image</th>
                                                    <th>Screen</th>
                                                    <th>Category</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    list.length ? (
                                                        list.map(banner => (
                                                            <tr key={banner.id}>
                                                                <td>{banner.id}</td>
                                                                <td>{banner.title ||''}</td>
                                                                <td>
                                                                    {banner.bannerImage ? <img src={banner.bannerImage} alt={banner.title} width="80px" /> : '-'}
                                                                </td>
                                                                <td className="text-capitalize">{banner.screen}</td>
                                                                <td>{(categories.find(category => category.id === banner.categoryId) || {}).displayName || '-'}</td>
                                                                <td>
                                                                    <button title="Edit Banner" className="btn btn-xs btn-info" onClick={() => this.editBanner(banner)}>
                                                                        <i className="fa fa-pencil-square-o" />
                                                                    </button>
                                                                    <button title="Delete Banner" className="btn btn-xs btn-danger ml-2" onClick={() => this.deleteBanner(banner)}>
                                                                        <i className="fa fa-trash" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">No Records Found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BannerModal
                    show={showModal}
                    onHide={this.closeModal}
                    categories={categories}
                    subCategories={subCategories}
                    data={bannerToEdit}
                    onCategoryChange={this.onCategoryChange}
                    addBanner={this.onAddBanner}
                    editBanner={this.onEditBanner}
                />
                <Alert
                    show={!!bannerToDelete}
                    onHide={() => this.setState({ bannerToDelete: null })}
                    title="Delete Banner"
                    message={`Are you sure you want to delete Banner ID: ${(bannerToDelete || {}).id}?`}
                    onSubmit={this.handleDeleteBanner}
                />
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    banners: {
        loading,
        error,
        list,
        showModal,
    },
    products: {
        categories,
        subCategories,
    },
}) => ({
    loading,
    error,
    list,
    categories,
    subCategories,
    showModal,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Banners)